/* eslint-disable no-console */
import { availableAtScreenSize } from './utils';
import { getCookie, setCookie } from '../../utils/cookie-utils';
import { removeAllErrors, validate, validateByType } from '../../utils/form-validation-utils';
import SitePopup from '../site-popup';

const COOKIE_NAME = 'sst-ci-popped';
const modalId = 'ci-modal';
let modalDiv = null;
let modal = null;

const isAvailable = () => {
  const { location } = window;
  // Remove -modal from id before adding to params
  const shortId = modalId.substring(0, modalId.indexOf('-modal'));
  const url = `/api/IsCiPopupNeeded?id=${shortId}&currentPage=${location}`;
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
    })
      .then((response) => {
        if (response.ok) {
          response.text().then(resolve);
        } else {
          response.text().then(reject);
        }
      })
      .catch(console.error);
  });
};

const isLeadSubmitted = () => {
  const email = document.getElementById('ci-email').value;
  const phone = document.getElementById('ci-phone').value;
  const zipCode = document.getElementById('ci-zipcode').value;
  const url = `/api/PostCiRebate?email=${email}&phone=${phone}&zip=${zipCode}`;
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
      },
    })
      .then((response) => {
        if (response.ok) {
          response.json().then(resolve);
        } else {
          response.json().then(reject);
        }
      })
      .catch(console.error);
  });
};

const isZipCodeSubmitted = (zipCode) => {
  const url = `/api/GetDealer?zipCode=${zipCode}`;
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
      },
    })
      .then((response) => {
        if (response.ok) {
          response.json().then(resolve);
        } else {
          response.json().then(reject);
        }
      })
      .catch(console.error);
  });
};

const onSubmitClick = (event) => {
  const { gatorApi } = window;
  const form = modalDiv.querySelector('.ci-form');
  const contentDiv = modalDiv.querySelector('.modal-content');
  const altContentDiv = modalDiv.querySelector('.modal-alternate-content');
  console.log(event);
  event.preventDefault();
  removeAllErrors(form);
  if (!validate(form)) {
    modal.updateHeight();
    return;
  }
  // Log with gator.io
  if (gatorApi) {
    const email = document.getElementById('ci-email').value;
    const phone = document.getElementById('ci-phone').value;
    gatorApi.log('Pop $100', '', '', '', email, phone);
  }
  // Submit form
  isLeadSubmitted()
    .then((data) => {
      if (data.isOk) {
        contentDiv.classList.add('hidden');
        altContentDiv.classList.remove('hidden');
        modal.updateHeight();
      } else {
        console.log(data);
      }
    });
};

const addDealerResultInfo = (data) => {
  const dealerLoookupResult = modalDiv.querySelector('.dealer-lookup-result');
  dealerLoookupResult.classList.remove('hidden');
  document.getElementById('ci-pop-dealer-name').innerHTML = data.dealer.CompanyName;
  document.getElementById('ci-pop-dealer-address').innerHTML = `${data.dealer.City}, ${data.dealer.State}, ${data.dealer.Zip}`;
  document.getElementById('ci-pop-dealer-phone').innerHTML = data.dealer.Phone;
  // Set focus to phone input
  document.getElementById('ci-phone').focus();
  // Resize modal
  modal.updateHeight();
};

const removeDealerResultInfo = () => {
  const dealerLoookupResult = modalDiv.querySelector('.dealer-lookup-result');
  dealerLoookupResult.classList.add('hidden');
  // Resize modal
  modal.updateHeight();
};

const onZipEntry = () => {
  const zipCodeIpt = document.getElementById('ci-zipcode');
  const zipCode = zipCodeIpt.value;
  if (validateByType('zipcode', zipCode)) {
    // Submit form
    isZipCodeSubmitted(zipCode)
      .then((data) => {
        if (data.isOk) {
          addDealerResultInfo(data);
        } else {
          removeDealerResultInfo();
        }
      });
  } else {
    removeDealerResultInfo();
  }
};

const addDealerZipSearch = () => {
  const emailIpt = document.getElementById('ci-email');
  const zipCodeIpt = document.getElementById('ci-zipcode');
  emailIpt.addEventListener('keyup', () => {
    const optionalDealerLookupDiv = modalDiv.querySelector('.optional-dealer-lookup');
    optionalDealerLookupDiv.classList.remove('hidden');
    zipCodeIpt.addEventListener('keyup', onZipEntry);
    modal.updateHeight();
  });
};

const initModal = (modalHtml) => {
  // Append html to the end of the DOM
  const body = document.querySelector('body');
  const div = document.createElement('div');
  div.innerHTML = modalHtml.trim();
  body.appendChild(div.firstChild);
  // Define div references
  modalDiv = document.getElementById(modalId);
  modal = new SitePopup({
    callbacks: {
      onOpen: () => {
        [].map.call(modalDiv.querySelectorAll('.submit-btn'), btn => (
          btn.addEventListener('click', onSubmitClick)
        ));
        setCookie(COOKIE_NAME, 'yes', 360);
        // Add zip toggle to email keydown
        addDealerZipSearch();
      },
    },
    id: modalId,
  });
  modal.open();
};

const ciPopup = () => {
  const { sitePopupsEnabled } = window;

  const popupCriteria = availableAtScreenSize() && sitePopupsEnabled && getCookie(COOKIE_NAME) === '';
  if (!popupCriteria) {
    return;
  }

  isAvailable()
    .then((data) => {
      if (data !== '~error~') {
        initModal(data);
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export default ciPopup;
/* eslint-enable no-console */
